import * as React from "react";
import { Typography, ListItem } from "@material-ui/core";

import withStyles, { WithStyles } from "@material-ui/core/styles/withStyles";
import ListIcon from "../ListIcon/ListIcon";
import { styles } from "./Plus.style";

// TODO: @bm - set up type properly

type ListItem = {
    icon: string;
    text: string
};

interface PlusProps extends WithStyles<typeof styles> {
    list: ListItem[];
}

class Plus extends React.Component<PlusProps> {

    public render() {

        const classes = this.props.classes;

        return (
            <>
                <Typography variant="subheading" component="h3" className={classes.title}>Les plus</Typography>
                <ListIcon list={this.props.list}/>
            </>
        );
    }

}

export default withStyles(styles)(Plus);


// WEBPACK FOOTER //
// ./src/components/Plus/Plus.tsx